import React, { useState } from "react";

export default function AnugyaPriceList() {
  const [mode, setMode] = useState("individual");

  return (
    <div className="p-4 text-white space-y-6">

      {/* HEADER + TOGGLE */}
      <div className="bg-slate-900 p-4 rounded-2xl space-y-3">

        <h2 className="text-xl font-bold flex items-center gap-2 text-yellow-400">
          <i className="fa-solid fa-wallet text-yellow-400"></i>
          Anugya Wallet & Token System
        </h2>

        <p className="text-sm text-slate-300">
          Choose pricing model: Individual or Institutional
        </p>

        {/* TOGGLE */}
        <div className="flex gap-3 mt-3">
          <button
            onClick={() => setMode("individual")}
            className={`w-1/2 p-2 rounded-xl text-xs lg:text-sm font-semibold ${
              mode === "individual"
                ? "bg-blue-600"
                : "bg-slate-800"
            }`}
          >
            Individual
          </button>

          <button
            onClick={() => setMode("institutional")}
            className={`w-1/2 p-2 rounded-xl text-xs lg:text-sm font-semibold ${
              mode === "institutional"
                ? "bg-indigo-600"
                : "bg-slate-800"
            }`}
          >
            Institutional
          </button>
        </div>
      </div>

      {/* ===================== */}
      {/* INDIVIDUAL SECTION */}
      {/* ===================== */}

      {mode === "individual" && (
        <div className="space-y-6">

          {/* FREE OFFER */}
          <div className="bg-blue-950 p-4 rounded-2xl border border-blue-700">
            <h3 className="font-bold flex items-center gap-2 text-cyan-200">
              <i className="fa-solid fa-gift text-blue-400"></i>
              Free for Individual Users
            </h3>

            <p className="text-sm text-slate-300 mt-2">
              New users get welcome credits after activating wallet.
            </p>

            <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="bg-slate-900 p-3 rounded-xl">
                <p className="text-yellow-300 font-semibold">
                  500 Anugya Tokens
                </p>
                <p className="text-xs text-slate-400">
                  Value: ₹100 equivalent
                </p>
              </div>

              <div className="bg-slate-900 p-3 rounded-xl">
                <p className="text-green-300 font-semibold">
                  Welcome Bonus
                </p>
                <p className="text-xs text-slate-400">
                  On “Claim Wallet” action
                </p>
              </div>
            </div>
          </div>

          {/* EARNING */}
          <div className="bg-slate-900 p-4 rounded-2xl">
            <h3 className="font-bold mb-3 text-cyan-200">
              <i className="fa-solid fa-coins text-yellow-400"></i> Earning Logic
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              {[
                ["🧾 Registration", "+100 points"],
                ["📦 Subscription", "Equivalent points"],
                ["🛒 Purchases", "Equivalent points"],
                ["🤝 Referrals", "Matching value"],
                ["📢 Engagement", "Wallet credits"],
                ["🏆 Achievements", "Bonus tokens"]
              ].map(([t, v], i) => (
                <div key={i} className="bg-slate-800 p-3 rounded-xl">
                  <p className="text-purple-200">{t}</p>
                  <p className="text-green-400 font-semibold">{v}</p>
                </div>
              ))}
            </div>
          </div>

          {/* REDEMPTION */}
          <div className="bg-slate-900 p-4 rounded-2xl">
            <h3 className="font-bold mb-3 text-cyan-200">
              <i className="fa-solid fa-recycle text-blue-400"></i> Redemption Logic
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              {[
                ["📄 Upload", "1 token / MB"],
                ["🔐 Consent", "1 token / MB"],
                ["🖨 Print", "Variable"],
                ["👁 View Docs", "1 token / MB"],
                ["📊 Audit Logs", "1 token"],
                ["🧠 AI Analytics", "5 tokens"]
              ].map(([t, v], i) => (
                <div key={i} className="bg-slate-800 p-3 rounded-xl">
                  <p className="text-purple-200">{t}</p>
                  <p className="text-red-400 font-semibold">{v}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      )}

      {/* ===================== */}
      {/* INSTITUTIONAL SECTION */}
      {/* ===================== */}

      {mode === "institutional" && (
        <div className="space-y-6">

          {/* CORE MODEL */}
          <div className="bg-indigo-950 p-4 rounded-2xl border border-indigo-700">
            <h3 className="font-bold text-cyan-200 flex items-center gap-2">
              <i className="fa-solid fa-building text-indigo-300"></i>
              Institutional Governance Pricing
            </h3>

            <p className="text-sm text-slate-300 mt-2">
              Usage-based infrastructure model for BFSI, MSME & enterprises.
            </p>
          </div>

          {/* CORE UNITS */}
          <div className="bg-slate-900 p-4 rounded-2xl">
            <h3 className="font-bold text-cyan-200 mb-3">
              Core Billing Units
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">

              {[
                ["🔐 Consent Executions", "Per 10K / 100K / 1M calls"],
                ["📄 Document Processing", "Per GB / TB usage"],
                ["🧠 AI Signal Engine", "Event-based pricing"],
                ["📊 Audit Storage", "Retention-based billing"],
                ["🔌 API Integration", "Per system connection"],
                ["⚖ Compliance Layer", "Enterprise governance tier"]
              ].map(([t, v], i) => (
                <div key={i} className="bg-slate-800 p-3 rounded-xl">
                  <p className="text-indigo-200">{t}</p>
                  <p className="text-slate-300 text-xs mt-1">{v}</p>
                </div>
              ))}
            </div>
          </div>

          {/* VALUE STATEMENT */}
          <div className="bg-gradient-to-r from-indigo-950 to-slate-900 p-4 rounded-2xl border border-indigo-700">
            <p className="text-sm text-slate-300">
              ⚡ Designed for compliance-heavy ecosystems where governance is more important than software pricing.
            </p>
          </div>

        </div>
      )}

    </div>
  );
}